import { useSelector } from '@hh.ru/front-static-app';

import { ProfileDto } from 'src/types/profile';

interface UseProfile {
    profile: ProfileDto | null;
    profileFullName: string;
    profileDescription: string;
    isAuth: boolean;
    isProfileComplete: boolean;
    isProfileIncomplete: boolean;
}

const getProfessionWithGrade = (profile: ProfileDto | null) => {
    if (!profile) {
        return '';
    }

    return [profile.profession?.name, profile?.grade?.name].filter(Boolean).join(' · ');
};

const useProfile = (): UseProfile => {
    const profile = useSelector((state) => state.profile);

    return {
        profile,
        profileFullName: profile ? profile.fullName : '',
        profileDescription: getProfessionWithGrade(profile),
        isAuth: !!profile,
        isProfileComplete: Boolean(profile?.profession?.inCareer && profile?.grade),
        isProfileIncomplete: Boolean(profile && !profile?.profession?.inCareer),
    };
};

export default useProfile;
